/* eslint-disable indent */
import { dateProvider } from '@utils';
import { Divider, Drawer, Flex, Image, Popover } from 'antd';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';

import { RelatedPostsToPost } from '../RelatedPosts';

import {
  DateWrapper,
  FeaturedTag,
  ImageWrapper,
  PostContentWrapper,
  SubtitleWrapper,
  TitleWrapper
} from './PostViewer.style';

import { useIsMobile } from '@/hooks';
import { usePostViewer } from '@/pages/Student/Dashboard/hooks';
import { usePostDetail } from '@/store';

export const PostViewer: React.FC = () => {
  const { t } = useTranslation('CommonDashboardTranslations');
  const { postId, setPostId } = usePostViewer();
  const { post } = usePostDetail(postId);
  const isMobile = useIsMobile();

  const DRAWER_WIDTH = isMobile ? '100%' : 600;

  if (!post) return null;

  const {
    _id,
    title,
    topic,
    content,
    tags,
    isFeatured,
    createdAt,
    featuredImage,
    scheduledPublishDate
  } = post;

  const tagCount = tags?.length || 0;
  const tagsNames = tags?.map(tag => tag.name).join(', ');

  return (
    <Drawer open={!!postId} width={DRAWER_WIDTH} onClose={() => setPostId(undefined)}>
      {isFeatured && <FeaturedTag>{t('FEATURED_NEWS')}</FeaturedTag>}
      <Flex vertical gap={24}>
        <Flex vertical gap={14}>
          <TitleWrapper>{title}</TitleWrapper>
          <SubtitleWrapper>
            <DateWrapper>
              <div>
                {scheduledPublishDate
                  ? dateProvider.format(
                      dateProvider.zonedTimeToUtc(scheduledPublishDate),
                      'dd MMM, yyyy'
                    )
                  : dateProvider.format(createdAt, 'dd MMM, yyyy')}
              </div>
            </DateWrapper>
            <span> • </span>
            {topic?.name}
            {tagCount > 0 && (
              <>
                <span> • </span>
                <Popover title={t('TAGS')} content={<div>{tagsNames}</div>}>
                  <div>{t('POST_TAGS_COUNT', { count: tagCount })}</div>
                </Popover>
              </>
            )}
          </SubtitleWrapper>
        </Flex>
        <ImageWrapper>
          <Image width="100%" height={320} preview={false} alt={title} src={featuredImage?.url} />
        </ImageWrapper>
        <PostContentWrapper
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content ?? '') }}
        />
      </Flex>
      <Divider />
      <RelatedPostsToPost postId={_id} />
    </Drawer>
  );
};
